/**
 * USER STORE CONTEXT
 * Manages user-related state including username, points, goals, and user data
 */

// Action imports
import { UserAction } from '../action/UserAction';

// Context utilities
import { ContextBase } from './construct/ContextBase';
import { useStore } from './construct/useStore';

/**
 * Initial state for user data
 */
const initialState = {
  username: 'n/a',        // User's display name
  Users: 0,               // User count (legacy field)
  currentGoal: {},        // Current active goal
  points: 0,              // Current user points
  targetPoints: 0,        // Target points goal
  margin:0
};

/**
 * User state reducer
 * Handles state updates for user-related actions
 * @param {Object} state - Current state
 * @param {Object} action - Action object with type and payload
 * @returns {Object} Updated state
 */
const reducer = (state, action) => {
  switch (action.type) {
    case 'SimpleUpdate':
      // Simple update action - merge action properties into state
      let { type, ...rest } = action;
      return {
        ...state,
        ...rest,
      };
    default:
      return state;
  }
};

// Create user store with initial state and reducer
export const UserStore = useStore({ initialState, reducer });

// Create custom hook for user context with actions
export const useUserContext = () => new ContextBase(UserStore, UserAction);
